import { useState, useEffect } from 'react';

function useWindowSize() {
	const [windowSize, setWindowSize] = useState({
		width: undefined,
		height: undefined,
	});
	useEffect(() => {
		function handleResize() {
			setWindowSize({
				width: window.innerWidth,
				height: window.innerHeight,
			});
		}
		window.addEventListener('resize', handleResize, { passive: true });
		handleResize();
		return () => window.removeEventListener('resize', handleResize, { passive: true });
	}, []);
	return windowSize;
}
export { useWindowSize };